import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import logosFlag from '../../media/logos-flag.png';
import cursorLeaf1 from '../../media/cursor-leaf-1.png';
import loginBg from '../../media/login-bg.png';
import heroWithAnimals from '../../media/illustration-hero-with-animals.png';
import lobbyBg from '../../media/lobby-bg.png';
import logoSmall from '../../media/logo-small.png';
import worldATitle from '../../media/world-a-title.png';
import worldBTitle from '../../media/world-b-title.png';
import worldCTitle from '../../media/world-c-title.png';
import worldDTitle from '../../media/world-d-title__2.png';
import avatarBg from '../../media/avatar-bg.png';
import waterLeaf from '../../media/illustration-water-leaf.png';
import woodTitle from '../../media/illustration-wood-title.png';
import controlColorWhite from '../../media/control-color-white.png';
import controlColorDark from '../../media/control-color-dark.png';
import controlColorBlack from '../../media/control-color-black.png';
import controlGenreMale from '../../media/control-genre-male.png';
import controlGenreFemale from '../../media/control-genre-female.png';
import controlArrowLeft from '../../media/control-arrow-left.png';
import controlArrowRight from '../../media/control-arrow-right.png';
import controlButtonOk from '../../media/control-button-ok.png';
import controlButtonSound from '../../media/control-sound.png';
import controlVideo from '../../media/control-video.png';
import controlMusicOn from '../../media/control-music-on.png';
import controlMusicOff from '../../media/control-music-off.png';
import controlButtonEdit from '../../media/control-button-edit.png';
import controlSkinNature from '../../media/control-skin-nature.png';
import controlSkinDanta from '../../media/control-skin-danta.png';
import controlSkinMonkey from '../../media/control-skin-monkey.png';
import controlSkinTurkey from '../../media/control-skin-turkey.png';
import controlSkinBird from '../../media/control-skin-bird.png';
import characterNatureWhiteMale from '../../media/avatars/nature_white_male.png';
import characterNatureWhiteFemale from '../../media/avatars/nature_white_female.png';
import characterNatureDarkMale from '../../media/avatars/nature_dark_male.png';
import characterNarureDarkFemale from '../../media/avatars/nature_dark_female.png';
import characterNatureBlackMale from '../../media/avatars/nature_black_male.png';
import characterNatureBlackFemale from '../../media/avatars/nature_black_female.png';
import characterDantaWhiteMale from '../../media/avatars/danta_white_male.png';
import characterDantaWhiteFemale from '../../media/avatars/danta_white_female.png';
import characterDantaDarkMale from '../../media/avatars/danta_dark_male.png';
import characterDantaDarkFemale from '../../media/avatars/danta_dark_female.png';
import characterDantaBlackMale from '../../media/avatars/danta_black_male.png';
import characterDantaBlackFemale from '../../media/avatars/danta_black_female.png';
import characterMonkeyWhiteMale from '../../media/avatars/monkey_white_male.png';
import characterMonkeyWhiteFemale from '../../media/avatars/monkey_white_female.png';
import characterMonkeyDarkMale from '../../media/avatars/monkey_dark_male.png';
import characterMonkeyDarkFemale from '../../media/avatars/monkey_dark_female.png';
import characterMonkeyBlackMale from '../../media/avatars/monkey_black_male.png';
import characterMonkeyBlackFemale from '../../media/avatars/monkey_black_female.png';
import characterTurkeyWhiteMale from '../../media/avatars/turkey_white_male.png';
import characterTurkeyWhiteFemale from '../../media/avatars/turkey_white_female.png';
import characterTurkeyDarkMale from '../../media/avatars/turkey_dark_male.png';
import characterTurkeyDarkFemale from '../../media/avatars/turkey_dark_female.png';
import characterTurkeyBlackMale from '../../media/avatars/turkey_black_male.png';
import characterTurkeyBlackFemale from '../../media/avatars/turkey_black_female.png';
import characterBirdWhiteMale from '../../media/avatars/bird_white_male.png';
import characterBirdWhiteFemale from '../../media/avatars/bird_white_female.png';
import characterBirdDarkMale from '../../media/avatars/bird_dark_male.png';
import characterBirdDarkFemale from '../../media/avatars/bird_dark_female.png';
import characterBirdBlackMale from '../../media/avatars/bird_black_male.png';
import characterBirdBlackFemale from '../../media/avatars/bird_black_female.png';
import modeBg from '../../media/mode-bg.png';
import worldModeOptionsTitle from '../../media/world-mode-options-title.png';
import modeOptionSingle from '../../media/mode-option-single.png';
import modeOptionMultiple from '../../media/mode-option-multiple.png';
import worldMultipleModeDialog from '../../media/world-multiple-mode-dialog.png';
import multipleOptionBack from '../../media/multiple-option-back.png';
import multipleOptionJoin from '../../media/multiple-option-join.png';
import introBg from '../../media/intro-bg.png';
import introCounterBackground from '../../media/intro-counter-background.png';
import questionBoard from '../../media/question-board.png';
import questionCard from '../../media/question-card.png';
import scoreBg from '../../media/score-bg.png';
import characterCap from '../../media/character-cap.png';
import scoreReviewBoard from '../../media/score-review-board.png';
import scoreHeroBadge from '../../media/score-hero-badge.png';
import introButtonStart from '../../media/intro-button-start.png';
import introCB1 from '../../media/intro/cuenca-baja/1.jpg';
import introCB2 from '../../media/intro/cuenca-baja/2.jpg';
import introCB3 from '../../media/intro/cuenca-baja/3.jpg';
import introCB4 from '../../media/intro/cuenca-baja/4.jpg';
import introCB5 from '../../media/intro/cuenca-baja/5.jpg';
import introCM1 from '../../media/intro/cuenca-media/1.jpg';
import introCM2 from '../../media/intro/cuenca-media/2.jpg';
import introCM3 from '../../media/intro/cuenca-media/3.jpg';
import introCM4 from '../../media/intro/cuenca-media/4.jpg';
import introCM5 from '../../media/intro/cuenca-media/5.jpg';
import introCM6 from '../../media/intro/cuenca-media/6.jpg';
import introCM7 from '../../media/intro/cuenca-media/7.jpg';
import introCA1 from '../../media/intro/cuenca-alta/1.jpg';
import introCA2 from '../../media/intro/cuenca-alta/2.jpg';
import introCA3 from '../../media/intro/cuenca-alta/3.jpg';
import introCA4 from '../../media/intro/cuenca-alta/4.jpg';
import introCA5 from '../../media/intro/cuenca-alta/5.jpg';
import introCA6 from '../../media/intro/cuenca-alta/6.jpg';
import introCA7 from '../../media/intro/cuenca-alta/7.jpg';
import introCA8 from '../../media/intro/cuenca-alta/8.jpg';
import introCA9 from '../../media/intro/cuenca-alta/9.jpg';
import introGL1 from '../../media/intro/glaciar/1.jpg';
import introGL2 from '../../media/intro/glaciar/2.jpg';
import introGL3 from '../../media/intro/glaciar/3.jpg';
import introGL4 from '../../media/intro/glaciar/4.jpg';
import introGL5 from '../../media/intro/glaciar/5.jpg';
import introGL6 from '../../media/intro/glaciar/6.jpg';
import cardCB1 from '../../media/questionnaires/cb_1.png';
import cardCB2 from '../../media/questionnaires/cb_2.png';
import cardCB3 from '../../media/questionnaires/cb_3.png';
import cardCB4 from '../../media/questionnaires/cb_4.png';
import cardCB5 from '../../media/questionnaires/cb_5.png';
import cardCM1 from '../../media/questionnaires/cm_1.png';
import cardCM2 from '../../media/questionnaires/cm_2.png';
import cardCM3 from '../../media/questionnaires/cm_3.png';
import cardCM4 from '../../media/questionnaires/cm_4.png';
import cardCM5 from '../../media/questionnaires/cm_5.png';
import cardCM6 from '../../media/questionnaires/cm_6.png';
import cardCA1 from '../../media/questionnaires/ca_1.png';
import cardCA2 from '../../media/questionnaires/ca_2.png';
import cardCA3 from '../../media/questionnaires/ca_3.png';
import cardCA4 from '../../media/questionnaires/ca_4.png';
import cardCA5 from '../../media/questionnaires/ca_5.png';
import cardCA6 from '../../media/questionnaires/ca_6.png';
import cardGL1 from '../../media/questionnaires/gl_1.png';
import cardGL2 from '../../media/questionnaires/gl_2.png';
import cardGL3 from '../../media/questionnaires/gl_3.png';
import cardGL4 from '../../media/questionnaires/gl_4.png';
import cardGL5 from '../../media/questionnaires/gl_5.png';
import cardGL6 from '../../media/questionnaires/gl_6.png';
import Information from '../../components/common/Information';

const Splash = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const gameImages = [
            logosFlag,
            cursorLeaf1,
            loginBg,
            heroWithAnimals,
            lobbyBg,
            logoSmall,
            worldATitle,
            worldBTitle,
            worldCTitle,
            worldDTitle,
            avatarBg,
            waterLeaf,
            woodTitle,
            controlColorWhite,
            controlColorDark,
            controlColorBlack,
            controlGenreMale,
            controlGenreFemale,
            controlArrowLeft,
            controlArrowRight,
            controlButtonOk,
            controlButtonSound,
            controlVideo,
            controlMusicOn,
            controlMusicOff,
            controlSkinNature,
            controlSkinDanta,
            controlSkinMonkey,
            controlSkinTurkey,
            controlSkinBird,
            characterNatureWhiteMale,
            characterNatureWhiteFemale,
            characterNatureDarkMale,
            characterNarureDarkFemale,
            characterNatureBlackMale,
            characterNatureBlackFemale,
            characterDantaWhiteMale,
            characterDantaWhiteFemale,
            characterDantaDarkMale,
            characterDantaDarkFemale,
            characterDantaBlackMale,
            characterDantaBlackFemale,
            characterMonkeyWhiteMale,
            characterMonkeyWhiteFemale,
            characterMonkeyDarkMale,
            characterMonkeyDarkFemale,
            characterMonkeyBlackMale,
            characterMonkeyBlackFemale,
            characterTurkeyWhiteMale,
            characterTurkeyWhiteFemale,
            characterTurkeyDarkMale,
            characterTurkeyDarkFemale,
            characterTurkeyBlackMale,
            characterTurkeyBlackFemale,
            characterBirdWhiteMale,
            characterBirdWhiteFemale,
            characterBirdDarkMale,
            characterBirdDarkFemale,
            characterBirdBlackMale,
            characterBirdBlackFemale,
            modeBg,
            worldModeOptionsTitle,
            modeOptionSingle,
            modeOptionMultiple,
            worldMultipleModeDialog,
            multipleOptionBack,
            multipleOptionJoin,
            introBg,
            introCounterBackground,
            questionBoard,
            questionCard,
            scoreBg,
            characterCap,
            scoreReviewBoard,
            scoreHeroBadge,
            controlButtonEdit,
            introButtonStart,
            introCB1,
            introCB2,
            introCB3,
            introCB4,
            introCB5,
            introCM1,
            introCM2,
            introCM3,
            introCM4,
            introCM5,
            introCM6,
            introCM7,
            introCA1,
            introCA2,
            introCA3,
            introCA4,
            introCA5,
            introCA6,
            introCA7,
            introCA8,
            introCA9,
            introGL1,
            introGL2,
            introGL3,
            introGL4,
            introGL5,
            introGL6,
            cardCB1,
            cardCB2,
            cardCB3,
            cardCB4,
            cardCB5,
            cardCM1,
            cardCM2,
            cardCM3,
            cardCM4,
            cardCM5,
            cardCM6,
            cardCA1,
            cardCA2,
            cardCA3,
            cardCA4,
            cardCA5,
            cardCA6,
            cardGL1,
            cardGL2,
            cardGL3,
            cardGL4,
            cardGL5,
            cardGL6,
        ];

        gameImages.forEach((image, index) => {
            new Image().src = image;

            if (index === gameImages.length - 1) {
                setTimeout(() => {
                    setIsLoading(false);
                }, 5000);
            }
        });
    }, []);

    const handleStartGame = () => {
        history.push(`${process.env.PUBLIC_URL}/login`);
    };

    return (
        <>
            <div className="page-container page-splash animate__animated animate__fadeIn">
                <img
                    src={logosFlag}
                    className="common-logos animate__animated animate__slideInDown"
                    alt="Héroes de la Cuenca"
                />
                <div className="status animate__animated animate__zoomIn animate__faster">
                    {isLoading ? (
                        <>
                            <span className="label">Cargando...</span>
                            <div className="loader">
                                <div className="bar"></div>
                            </div>
                        </>
                    ) : (
                        <div
                            className="label animate__animated animate__heartBeat animate__infinite"
                            onClick={handleStartGame}
                        >
                            ¡Empezar!
                        </div>
                    )}
                </div>
            </div>
            <Information helpText='¡Haz clic en el botón "EMPEZAR" para iniciar la aventura!' />
        </>
    );
};

export default Splash;
